import { FormField } from '../../FormField';
import { memo } from 'react';
import { CellContext } from '@tanstack/react-table';
import { getFormTableFieldName } from './utils';
import { FormCheckbox } from '../../input';
import { Flex } from 'antd';

export const FormTableCheckboxField = (memo as <T>(c: T) => T)(
  <RowData,>(props: CellContext<RowData, any>) => {
    const name = getFormTableFieldName(props);
    return (
      <Flex justify="center" align="center">
        <FormField size="small" name={name} preview={false}>
          <FormCheckbox name={name} />
        </FormField>
      </Flex>
    );
  }
);
